// Angular imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Import modules
import { PipesModule } from '../pipes/pipes.module';

// Import components
import { TabViewComponent } from './tab-view/tab-view.component';
import { TabPageComponent } from './tab-page/tab-page.component';

@NgModule({
  declarations: [TabViewComponent, TabPageComponent],
  imports: [
    CommonModule, PipesModule, FormsModule
  ],
  exports: [ TabViewComponent, TabPageComponent ]
})
export class TabViewModule { }
